module.exports = __webpack_public_path__ + "img/qupiao_active.5055798f.png";